import React, {useMemo, useState, useEffect} from 'react';
import Header from '../../common/header';
import mapStateToProps from '../../redux/util';
import {connect} from 'react-redux';
import actions from '../../redux/action'
import { HEADER_TABS } from '../../redux/action/types'
import Styles from './index.module.scss';
import {Menu} from 'antd';
import ConfigManager from '../config/config-manager';
import DeviceManager from '../device/device-manager';
import DeviceManagerNew from '../device-new';
import i18next from 'i18next';
// import WithoutPermission from '../config/without-permission';
import {Redirect, Route, Switch} from 'react-router-dom';


function Privatisation(props) {
    const menus = useMemo(() => {
        return [{
            title: i18next.t('configs_manager'), route: '/private/access-configuration',
        }, {
            title: i18next.t('private_devices_manager'), route: '/private/device-binding',
        }];
    }, [props.locale]);
    const [currentPage, setCurrentPage] = useState(props.history.location.pathname);
    useEffect(() => {
        // 一级header切换
        props.changedTab(HEADER_TABS.privatisation);
        // sidebar切换
        const unListen = props.history.listen((location, action) => {
            setCurrentPage(location.pathname);
        });
    
        return () => {
            unListen(); 
        };
    },[])


    return <div className={ Styles.root }>
        <Header props={ props }/>
        <div className={ Styles.container }>
            <div className={ Styles.leftItem }>
                {/* <div className={ Styles.title }>{ i18next.t('privatisation') }</div> */}
                <Menu
                    inlineIndent={ 0 }
                    selectedKeys={ [currentPage] }
                    mode={ 'inline' }
                    inlineCollapsed={ false }
                    theme="dark">
                    { menus.map((item, index) => {
                        return (<Menu.Item key={ item.route } onClick={ () => {
                            props.history.push({
                                pathname: item.route,
                            });
                        } }>
                            <span>{ item.title }</span>
                        </Menu.Item>);
                    }) }
                </Menu>
            </div>
            <div className={ Styles.rightItem }>
                <Switch>
                    <Route path={ '/private/access-configuration' } exact component={ ConfigManager }/>
                    {/* <Route path={ '/private/device-binding' } component={ DeviceManager }/> */}
                    <Route path={ '/private/device-binding' } component={ DeviceManagerNew }/>
                    {/* <Route path={ '/privatisation/permission' } component={ WithoutPermission }/> */}
                    <Redirect to="/private/access-configuration"/>
                </Switch>
            </div>
        </div>
    </div>;
}

const mapDispatchToProps = (dispatch) => ({
    changedTab: (tab) => dispatch(actions.onChangeTab(tab)),
  })

export default connect(mapStateToProps,mapDispatchToProps)(Privatisation);

